import {Component, OnDestroy, OnInit} from '@angular/core'
import {GlobalMessageService} from '@spartacus/core'
import {PageLayoutService, ProductListComponent, ProductListComponentService, ViewConfig} from '@spartacus/storefront'
import {filter, Observable, Subscription, take} from 'rxjs'
import {EbAnalyticsService} from "../../../analytics/services/facades/eb-analytics.service";
import {EbProductSearchPage} from '../../interfaces/eb-product.interface'

@Component({
    selector: 'eb-product-grid',
    templateUrl: './eb-product-grid.component.html',
    styleUrls: ['./eb-product-grid.component.scss'],
    standalone: false
})
export class EbProductGridComponent extends ProductListComponent implements OnInit, OnDestroy  {
  model$: Observable<EbProductSearchPage>
  private readonly subscriptions = new Subscription()
  constructor(pageLayoutService: PageLayoutService,
              productListComponentService: ProductListComponentService,
              globalMessageService: GlobalMessageService,
              scrollConfig: ViewConfig,
              protected ebAnalyticsService:EbAnalyticsService) {
    super(pageLayoutService, productListComponentService, globalMessageService, scrollConfig)
  }

  ngOnInit() {
    super.ngOnInit();
    this.subscriptions.add(
      this.model$.pipe(
        take(1),
        filter(model => model.categoryName != null))
        .subscribe(model => this.ebAnalyticsService.pushViewCategoryEvents(model)
      )
    )
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe()
  }

}
